import { Auth } from 'types'

export enum UnregisteredUserActions {
  DISMISS_BANNER = 'DISMISS_UNREGISTERED_USER_BANNER',
  AUTHENTICATE_START = 'AUTHENTICATE_UNREGISTERED_USER_START',
  AUTHENTICATE_SUCCESS = 'AUTHENTICATE_UNREGISTERED_USER_SUCCESS',
  AUTHENTICATE_FAILURE = 'AUTHENTICATE_UNREGISTERED_USER_FAILURE',
  SET_NAME = 'SET_UNREGISTERED_USER_NAME',
  UNSET = 'UNSET_UNREGISTERED_USER',
}

interface SuccessPayload {
  authHeader: string
  user: Auth
}

interface SetNamePayload {
  first_name: string
  last_name: string
}

export type UnregisteredUserActionType =
  | { type: UnregisteredUserActions.AUTHENTICATE_START }
  | { type: UnregisteredUserActions.AUTHENTICATE_SUCCESS; payload: SuccessPayload }
  | { type: UnregisteredUserActions.AUTHENTICATE_FAILURE }
  | { type: UnregisteredUserActions.DISMISS_BANNER }
  | { type: UnregisteredUserActions.SET_NAME; payload: SetNamePayload }
  | { type: UnregisteredUserActions.UNSET }

export const authenticateStart = (): UnregisteredUserActionType => ({
  type: UnregisteredUserActions.AUTHENTICATE_START,
})

export const authenticateSuccess = (payload: SuccessPayload): UnregisteredUserActionType => ({
  type: UnregisteredUserActions.AUTHENTICATE_SUCCESS,
  payload,
})

export const authenticateFailure = (): UnregisteredUserActionType => ({
  type: UnregisteredUserActions.AUTHENTICATE_FAILURE,
})

export const dismissBanner = (): UnregisteredUserActionType => ({
  type: UnregisteredUserActions.DISMISS_BANNER,
})

export const setName = (payload: SetNamePayload): UnregisteredUserActionType => ({
  type: UnregisteredUserActions.SET_NAME,
  payload,
})

export const unset = (): UnregisteredUserActionType => ({
  type: UnregisteredUserActions.UNSET,
})
